import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

const ToolTipGroup = forwardRef((props, ref) => {
  const { tips } = props;
  
  const div = useRef();
  const [reload, setReload] = useState(false);
  useEffect(() => {
    if (reload) setReload(false);
  }, [reload]);
  useImperativeHandle(ref, () => ({
    reload() {
      setReload(true);
    },
    getBox() {
      return div.current.getBoundingClientRect();
    },
  }));

  return (
    <div>
      <div style={{ position: "relative" }} ref={div}>
        {tips?.current
          ?.filter((f) => f?.getTitle())
          .map((tip, index) => {
            const Title = () => tip?.getTitle();
            return <Title key={index} />;
          })}
      </div>
      {props.children}
    </div>
  );
});

export default ToolTipGroup;
